import React, {createContext, useContext, useEffect, useState} from 'react';
import jwtAxios from '../../@crema/services/auth/jwt-auth/jwt-api';
import {useAuthUser} from '../../@crema/utility/AuthHooks';

export type Event = {
  id: string;
};

type EventContextType = {
  events: Event[];
  loading: boolean;
};

interface EventActionsContextType {}

const defaultEventContext = {
  events: [],
  loading: false,
};

const EventContext = createContext<EventContextType>(defaultEventContext);

const EventActionsContext = createContext<EventActionsContextType>({});

export const useEventContext = () => useContext(EventContext);
export const useEventActionsContext = () =>
  useContext(EventActionsContext);

const EventProvider = ({children}: any) => {
  const {user} = useAuthUser();
  const [events, setEvents] = useState(defaultEventContext.events);
  const [loading, setLoading] = useState(defaultEventContext.loading);

  useEffect(() => {
    fetchEvents();
  }, []);

  const fetchEvents = () => {
    setLoading(true);
    Promise.all([
      getEvents().then(({data}) => setEvents(data.data)),
    ])
      .then(() => {
        setLoading(false);
      })
      .catch((e) => {
        console.log(e);
        setLoading(false);
      });
  };

  const getEvents = async () => {
    return jwtAxios.get(`/event/get-all/${user.id}`);
  };

  return (
    <EventContext.Provider
      value={{
        events,
        loading
      }}>
      <EventActionsContext.Provider
        value={{}}>
        {children}
      </EventActionsContext.Provider>
    </EventContext.Provider>
  );
};

export default EventProvider;
